const getPopoverStyles = (langDir) => ({
  style: {
    background: "#ffffff",
    color: "#000",
    fontFamily: "var(--ricos-settings-text-font-family, Helvetica Neue)",
    fontSize: 14,
    padding: 20,
    borderColor: "#000",
    borderRadius: "var(--ricos-settings-whitebox-border-radius, 2px)",
    boxShadow: "var(--ricos-settings-whitebox-box-shadow, 0 4px 8px 0 rgb(0 0 0 / 12%), 0 0 4px 0 rgb(0 0 0 / 10%))",
    transition: "none",
    maxWidth: 280,
    maxHeight: 120,
    zIndex: 1e7,
    direction: langDir,
    lineHeight: "20px"
  },
  arrowStyle: {
    transition: "none",
    color: "rgb(255,255,255)",
    borderColor: "rgb(0,0,0,.1)"
  }
});

export { getPopoverStyles as default };
//# sourceMappingURL=popoverStyles.js.map
